exports.isTrue = (val) => {
    return val === "true" || val === "1";
};
